/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */
export function csMarked(w, j) {
  // check node is marked
  return w[j] < 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/function/algebra/sparse/csMarked.js
// module id = null
// module chunks = 